import { useEffect } from 'react';
import { useFilterFromParams } from './useFilterFromParams';
import { useSetFilter } from './useSetFilter';

interface HookArgs {
  validFilters: string[];
  defaultFilter: string;
}

export const useFilter = ({ validFilters, defaultFilter }: HookArgs) => {
  let filter = useFilterFromParams() || '';
  const update = useSetFilter();

  useEffect(() => {
    if (!validFilters.includes(filter)) {
      update(defaultFilter);
    }
  }, [validFilters, update, defaultFilter, filter]);

  return {
    filter: validFilters.includes(filter) ? filter : defaultFilter,
    update,
  };
};
